import React, { useState } from "react";
import * as DialogPrimitive from "@radix-ui/react-dialog";
import { X } from "lucide-react";
import { toast } from "sonner";
import axios from "axios";

const BASE_URI = process.env.REACT_APP_API_BASE_URI;

const CounselingFormModal = ({
  open,
  onClose,
  title = "Get Free Counseling",
}) => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
    message: "",
  });
  const [formLoading, setFormLoading] = useState(false);
  const [formError, setFormError] = useState("");

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (
      !formData.name ||
      !formData.email ||
      !formData.mobile ||
      !formData.message
    ) {
      toast.warning("Please fill all required fields");
      return;
    }

    try {
      setFormLoading(true);
      await axios.post(`${BASE_URI}/mail/sendEmail`, formData, {
        headers: { "Content-Type": "application/json" },
      });
      toast.success("Your message has been sent!");
      setFormData({ name: "", email: "", mobile: "", message: "" });
      setFormError("");
      onClose();
    } catch (err) {
      console.error("Error sending email", err);
      setFormError("Failed to send message. Please try again.");
      toast.error("Failed to send message. Please try again.");
    } finally {
      setFormLoading(false);
    }
  };

  const handleOpenChange = (isOpen) => {
    if (!isOpen) onClose();
  };

  return (
    <DialogPrimitive.Root open={open} onOpenChange={handleOpenChange}>
      <DialogPrimitive.Portal>
        <DialogPrimitive.Overlay className="counseling-dialog-overlay" />
        <DialogPrimitive.Content className="counseling-dialog-content">
          {/* Header */}
          <div
            style={{
              padding: "20px 24px 16px",
              borderBottom: "1px solid #f0f0f0",
            }}
          >
            <DialogPrimitive.Title
              style={{
                margin: 0,
                fontSize: "18px",
                fontWeight: 600,
                color: "#111827",
              }}
            >
              {title}
            </DialogPrimitive.Title>
            <DialogPrimitive.Description
              style={{ margin: "4px 0 0", fontSize: "14px", color: "#6b7280" }}
            >
              We'll return to you as fast as we can!
            </DialogPrimitive.Description>
          </div>

          {/* Form Body */}
          <div style={{ padding: "16px 24px 24px" }}>
            <form onSubmit={handleSubmit}>
              <div className="row pt-2">
                <div className="col">
                  <label className="form-label contact-form-label">Name</label>
                  <input
                    type="text"
                    name="name"
                    className="form-control contact-form-inputArea"
                    value={formData.name}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="col">
                  <label className="form-label contact-form-label">Email</label>
                  <input
                    type="email"
                    name="email"
                    className="form-control contact-form-inputArea"
                    value={formData.email}
                    onChange={handleInputChange}
                    required
                  />
                </div>
              </div>
              <div className="pt-3">
                <label className="form-label contact-form-label">
                  Contact Number
                </label>
                <input
                  type="tel"
                  name="mobile"
                  className="form-control contact-form-inputArea"
                  pattern="[0-9]{10}"
                  maxLength={10}
                  value={formData.mobile}
                  onChange={handleInputChange}
                  onInput={(e) => {
                    e.target.value = e.target.value.replace(/\D/g, "");
                  }}
                  required
                />
              </div>
              <div className="pt-3">
                <label className="form-label contact-form-label">
                  Your Message
                </label>
                <textarea
                  name="message"
                  className="form-control contact-form-inputArea"
                  rows="3"
                  value={formData.message}
                  onChange={handleInputChange}
                  required
                ></textarea>
              </div>
              <div className="text-center mt-3 d-grid">
                <button
                  type="submit"
                  className="btn btn-primary"
                  disabled={formLoading}
                >
                  {formLoading ? "Submitting..." : "Submit"}
                </button>
              </div>
            </form>
          </div>

          {/* Close Button */}
          <DialogPrimitive.Close
            style={{
              position: "absolute",
              top: "14px",
              right: "16px",
              background: "transparent",
              border: "none",
              cursor: "pointer",
              color: "#9ca3af",
              padding: "4px",
              borderRadius: "6px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
            aria-label="Close"
          >
            <X size={18} />
          </DialogPrimitive.Close>
        </DialogPrimitive.Content>
      </DialogPrimitive.Portal>
    </DialogPrimitive.Root>
  );
};

export default CounselingFormModal;
